import moment from 'moment'

export default {
  methods: {
    m$formatDate(date, format) {
      return moment(date).format(format || 'YYYY-MM-DD HH:mm')
    }
  }
}
